
/*
 * @Author: liu yang and zhan lin sen
 * @Date: 2020-02-12 13:13:57
 * @LastEditTime : 2020-03-27 15:06:28
 * @LastEditors  : Please set LastEditors
 * @Description: 请求接口封装
 * @FilePath: \trunk\src\utils\http.js
 */

import http from "./util";
// 获取直通车新闻列表接口
export const QueryCmsNews = params => {
  return http.fetchGet("/api/CmsNews/QueryCmsNewsByColumnFile", params);
};
/**
 * 获取主页课程列表
 * @param {object} params 
 */
export const HomeCourses = params => {
  return http.Post("/homecourses", params);
};
/**
 * 获取导师列表
 * @param {object} params 
 */
export const CoursesTeachers = params => {
  return http.Post("/courseteachers", params);
};
/**
 * 获取导师信息
 * @param {object} params 
 */
export const CourseTeacherdetail = params => {
  return http.Post("/courseteacherdetail", params);
};
/**
 * 获取课程页列表
 * @param {object} params 
 */
export const ClassifiedCourses = params => {
  return http.Post("/classifiedcourses ", params);
};
/**
 * 获取课程标签列表
 * @param {object} params 
 */
export const CoursesLabels = params => {
  return http.Post("/courselabels ", params);
};
/**
 * 获取我的课程列表
 * @param {object} params 
 */
export const MyCourses = params => {
  return http.Post("/mycourses", params);
};
/**
 * 获取视频播放
 * @param {object} params 
 */
export const PlayVideo = params => {
  return http.Post("/videoplay", params);
};
/**
 * 获取课程详情
 * @param {object} params 
 */
export const CourseDetail = params => {
  return http.Post("/coursedetail", params);
};
/**
 * 更新时间
 * @param {object} params 
 */
export const RefreShtime = params => {
  return http.Post("/refreshtime", params);
};
/**
 * 订阅免费课程
 * @param {object} params 
 */
export const Subscribe = params => {
  return http.Post("/subscribe", params);
};
/**
 * 取消免费课程订阅
 * @param {object} params 
 */
export const RemoveSubscribe = params => {
  return http.Post("/removesubscribe", params);
};
/**
 * 获取免费课程列表
 * @param {object} params 
 */
export const FreeCourselist = params => {
  return http.Post("/freecourselist", params);
};

/**
 * 获取直播和预告列表
 * @param {object} params 
 */
export const getLiveList = params => {
  return http.Post("/live/notices", params);
}
/**
 * 获取回放列表
 * @param {object} params 
 */
export const getReviewList = params => {
  return http.Post("/live/playbackvideos", params);
}
/**
 * 获取课程详情页
 * @param {object} params 
 */
export const getLiveCourseDetail = params => {
  return http.Post("/live/livecoursedetail", params);
}
/**
 * 播放视频
 * @param {object} params 
 */
export const playLiveCourse = params => {
  return http.Post("/live/liveplay", params);
}
/**
 * 视频列表接口
 * @param {object} params 
 */
export const getCourseList = params => {
    return http.Post("/live/livevideodatalist", params);
}
/**
 * 记录播放时间
 * @param {object} params 
 */
export const refreshTime = params => {
    return http.Post("/live/refreshtime", params);
}
/**
 * 获取预告播放时间
 * @param {object} params 
 */
export const getStartTime = params => {
    return http.Post("/live/notice", params);
}